
    <!-- Overlay backdrop (mobile) -->
    @if (mobileOpen) {
      <div class="sidebar-overlay" (click)="closeMobile.emit()"></div>
    }

    <!-- Sidebar -->
    @if (activeGroup()) {
      <aside class="sidebar" [class.mobile-open]="mobileOpen" [class.sidebar--collapsed]="collapsed">
        <div class="sidebar__inner">
          <!-- Header -->
          <div class="sidebar__header">
            <div class="sidebar__header-top">
              <div>
                <h2 class="sidebar__title">{{ activeGroup()!.label }}</h2>
                <p class="sidebar__subtitle">Módulo Operativo</p>
              </div>
              <!-- Collapse (desktop) -->
              <button class="sidebar__collapse-btn" (click)="toggleCollapse.emit()" title="Ocultar menú">
                <span class="material-symbols-outlined">chevron_left</span>
              </button>
              <!-- Close (mobile) -->
              <button class="sidebar__close" (click)="closeMobile.emit()">
                <span class="material-symbols-outlined">close</span>
              </button>
            </div>
          </div>

          <!-- Navigation -->
          <nav class="sidebar__nav">
            @for (child of visibleChildren(); track child.route) {
              <a
                class="sidebar__link"
                [routerLink]="child.route"
                routerLinkActive="sidebar__link--active"
                [routerLinkActiveOptions]="{ exact: child.exact !== false }"
                (click)="onNavClick(child.route)"
              >
                <span
                  class="material-symbols-outlined sidebar__link-icon"
                  [style.font-variation-settings]="isActive(child.route) ? getFillSettings() : ''"
                >{{ child.icon }}</span>
                <span class="sidebar__link-label">{{ child.label }}</span>
              </a>
            }
          </nav>

          <!-- Footer: user info -->
          <div class="sidebar__footer">
            <div class="sidebar__user">
              @if (auth.user()?.photo) {
                <img [src]="auth.user()!.photo" alt="" class="sidebar__user-photo" />
              } @else {
                <div class="sidebar__user-avatar">{{ userInitials }}</div>
              }
              <div class="sidebar__user-info">
                <span class="sidebar__user-name">{{ auth.userDisplayName() }}</span>
                <span class="sidebar__user-role">{{ auth.user()?.role }}</span>
              </div>
            </div>
          </div>
        </div>
      </aside>
    }
